var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bold / Money / Wallet"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3761 10.0044C26.3053 9.99995 26.2282 9.99998 26.1482 10L26.1282 10H22.9926C20.408 10 18.1965 12.0345 18.1965 14.6875C18.1965 17.3406 20.408 19.375 22.9926 19.375H26.1282L26.1482 19.375C26.2282 19.375 26.3053 19.3751 26.3761 19.3706C27.426 19.3043 28.3544 18.4828 28.4325 17.3353C28.4376 17.26 28.4375 17.1789 28.4375 17.1037L28.4375 17.0833V12.2917L28.4375 12.2713C28.4375 12.1961 28.4376 12.115 28.4325 12.0397C28.3544 10.8923 27.426 10.0707 26.3761 10.0044ZM22.7146 15.9375C23.38 15.9375 23.9194 15.3779 23.9194 14.6875C23.9194 13.9971 23.38 13.4375 22.7146 13.4375C22.0492 13.4375 21.5098 13.9971 21.5098 14.6875C21.5098 15.3779 22.0492 15.9375 22.7146 15.9375Z",
    fill: "url(#paint0_linear_321_3614)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1474 21.25C26.3338 21.2452 26.4748 21.4178 26.4243 21.5972C26.1733 22.4878 25.7751 23.2468 25.1359 23.8859C24.2005 24.8214 23.0143 25.2365 21.5488 25.4336C20.1248 25.625 18.3052 25.625 16.008 25.625H13.367C11.0698 25.625 9.25024 25.625 7.82622 25.4336C6.36069 25.2365 5.17451 24.8214 4.23905 23.8859C3.3036 22.9505 2.88845 21.7643 2.69142 20.2988C2.49996 18.8748 2.49998 17.0552 2.5 14.758V14.617C2.49998 12.3198 2.49996 10.5002 2.69142 9.07622C2.88845 7.6107 3.3036 6.42451 4.23905 5.48905C5.17451 4.5536 6.36069 4.13845 7.82622 3.94142C9.25024 3.74997 11.0698 3.74998 13.367 3.75L16.008 3.75C18.3052 3.74998 20.1248 3.74996 21.5488 3.94142C23.0143 4.13845 24.2005 4.5536 25.1359 5.48905C25.775 6.12815 26.1733 6.88718 26.4243 7.77773C26.4748 7.95719 26.3338 8.12984 26.1474 8.12501L22.9925 8.12501C19.4467 8.12501 16.3214 10.9261 16.3214 14.6875C16.3214 18.4489 19.4467 21.25 22.9925 21.25L26.1474 21.25ZM7.1875 8.75C6.66973 8.75 6.25 9.16973 6.25 9.6875C6.25 10.2053 6.66973 10.625 7.1875 10.625H12.1875C12.7053 10.625 13.125 10.2053 13.125 9.6875C13.125 9.16973 12.7053 8.75 12.1875 8.75H7.1875Z",
    fill: "url(#paint1_linear_321_3614)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_321_3614",
    x1: 15.4688,
    y1: 3.75,
    x2: 15.4688,
    y2: 25.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AED1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#408EF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_321_3614",
    x1: 15.4688,
    y1: 3.75,
    x2: 15.4688,
    y2: 25.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AED1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#408EF6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.e15a79a512774baab5165ad4ddb59203.svg";
export { ForwardRef as ReactComponent };